import { render } from "./FocaleView.vue?vue&type=template&id=a3069dba&scoped=true"
import script from "./FocaleView.vue?vue&type=script&lang=js"
export * from "./FocaleView.vue?vue&type=script&lang=js"

import "./FocaleView.vue?vue&type=style&index=0&id=a3069dba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3069dba"]])

export default __exports__